import {UserComponent} from "../../user/user.component";
import {PopupDialogComponent} from "./popup-dialog.component";
import {Component} from "@angular/core";
import {NbDialogRef} from "@nebular/theme";

@Component({
    templateUrl: './popup-dialog.component.html',
    styleUrls: ['./popup-dialog.component.scss'],
    standalone: false
})
export class UserDialogComponent extends PopupDialogComponent<UserComponent>{
  protected component(): any {
    return UserComponent;
  }

  done(result: any = null) {
    this.ref.close(this.instance.user || null);
  }
}
